(function() {
    /* globals $, angular */
    'use strict';

    angular.module('dashboardApp').run(Run);

    Run.$inject = [
        '$window'
    ];


    function Run(
        $window
    ) {

        // $location.path('/start').replace();

        $window.com = $window.com || {};
        $window.com.imshealth = $window.com.imshealth || {};

    }


})();
